/**
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
//Standard libraries
import { createAction } from "@reduxjs/toolkit";
//Redux
import * as ACTIONTYPES from "../action-types/inprogressOrders";

const SET_INPROGRESS_ORDERS = createAction<any, string>(
  ACTIONTYPES.SET_INPROGRESS_ORDERS
);
const CLEAR_INPROGRESS_ORDES = createAction<any>(
    ACTIONTYPES.CLEAR_INPROGRESS_ORDES
);

export { SET_INPROGRESS_ORDERS, CLEAR_INPROGRESS_ORDES };